import { LanguageCase, UseGetLanguage } from './types.ts'
import { useStoreSelector } from 'hooks/store.ts'
import { getLowerCaseLanguage, getUpperCaseLanguage } from 'utils/language.ts'

/**
 * Export the language based on the given case - Default 'uppercase'
 * @type {UseGetLanguage}
 */
export const useGetLanguage = ((languageCase: LanguageCase = 'uppercase') => {
  const language = useStoreSelector((store) => store.app.language)

  if (languageCase === 'lowercase') {
    return getLowerCaseLanguage(language)
  }

  return getUpperCaseLanguage(language)
}) as UseGetLanguage
